import React from 'react';
import styled from 'styled-components';

const AudioButton = styled.div`
  text-align: center;
  margin-bottom: 15px;
`;
class AudioPlayer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { play: false };
    this.selectedId = props.selectedId;
    this.soundId = props.soundId;
    this.url = props.url;
    this.playIcon = props.playIcon;
    this.pauseIcon = props.pauseIcon;
    this.audio = new Audio(this.url);
    this.audio.preload = 'none';
    this.togglePlay = this.togglePlay.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    // You don't have to do this check first, but it can help prevent an unneeded render
    if (nextProps.selectedId !== this.selectedId) {
      if (nextProps.selectedId != this.soundId) {
        this.setState({ play: false });
        this.audio.pause();
      }
    }
  }
  playAudio() {
    const { handleStateChange } = this.props;
    this.audio.play();
    if (handleStateChange) {
      handleStateChange('selectedId', this.soundId);
    }
  }
  togglePlay() {
    this.setState({ play: !this.state.play }, () => {
      this.state.play ? this.playAudio() : this.audio.pause();
    });
  }

  componentWillUnmount() {
    this.audio.pause();
  }

  render() {
    return (
      <AudioButton>
        {this.state.play ? (
          <span
            style={{ cursor: 'pointer' }}
            aria-label="Pause"
            onClick={this.togglePlay}
          >
            <img src={this.pauseIcon} width="34" height="34" alt="Pause"></img>
          </span>
        ) : (
          <span
            style={{ cursor: 'pointer' }}
            aria-label="Play"
            onClick={this.togglePlay}
          >
            <img src={this.playIcon} width="34" height="34" alt="Play"></img>
          </span>
        )}
      </AudioButton>
    );
  }
}

export default AudioPlayer;



// WEBPACK FOOTER //
// src/modules/common/components/AudioPlayer.js